import React from "react";
import { formatarMoeda } from "../../../utils/calculos";
import { usePrecosVisiveis } from "../../../context/PrecosContext";
import {
  StackedCard,
  StackedLabel,
  StackedSub,
  StackedValue,
  StageBreakdownLine,
  StageBreakdownList,
} from "./styles";

export default function WipTotalCard({ totalWip, wipPorEtapa }) {
  const { precosVisiveis } = usePrecosVisiveis();
  const valorVisivel = precosVisiveis
    ? formatarMoeda(totalWip.valorRS)
    : "••••••";

  return (
    <StackedCard $tone="default" aria-label="Estoque em processo">
      <StackedLabel>Estoque em processo (WIP)</StackedLabel>
      <StackedValue>{totalWip.count} ambientes</StackedValue>
      <StackedSub>{valorVisivel} em obra</StackedSub>
      <StageBreakdownList>
        {wipPorEtapa.map((bucket) => (
          <StageBreakdownLine key={bucket.etapa}>
            <span>{bucket.label}</span>
            <strong>{bucket.count}</strong>
            <span>
              {precosVisiveis ? formatarMoeda(bucket.valorRS) : "••••••"}
            </span>
          </StageBreakdownLine>
        ))}
      </StageBreakdownList>
    </StackedCard>
  );
}
